module.exports = __webpack_public_path__ + "static/media/055-image.07977cbf.svg";